import React from 'react';
import useCapacitor from 'hooks/useCapacitor';
import { useHistory, withRouter } from 'react-router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import Cookies from 'js-cookie';

const CapacitorProvider = (props: any) => {
  useCapacitor();
  const history = useHistory();

  React.useEffect(() => {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      // Example url: https://beerswift.app/tabs/tab2
      // slug = /tabs/tab2
      // const slug = event.url.split('.app').pop();
      // if (slug) {
      //   history.push(slug);
      // }
      // history.push('/');
      // If no match, do nothing - let regular routing
      // logic take over
      if (event.url.startsWith('capacitor')) {
        try {
          const uri = decodeURI(event.url);
          const data = JSON.parse(
            uri.split('capacitor://localhost/?data=')?.[1]
          );
          const token = data?.token;
          history.replace(`/?refreshToken=${token}&token=${token}`);
        } catch (error) {}
      }
    });
    // App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    //   window.close();
    //   // this.zone.run(() => {
    //   //   const domain = 'devdactic.com';
    //   //   const pathArray = event.url.split(domain);
    //   //   // The pathArray is now like ['https://devdactic.com', '/details/42']
    //   //   // Get the last element with pop()
    //   //   const appPath = pathArray.pop();
    //   //   if (appPath) {
    //   //     this.router.navigateByUrl(appPath);
    //   //   }
    //   // });
    // });
  }, []);

  return null;
};

export default withRouter(CapacitorProvider);
